/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetRouteImport } from './routes/reset'
import { Route as ProfilRouteImport } from './routes/profil'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TasksTaskIdRouteImport } from './routes/tasks/$taskId'
import { Route as ProfilFacturesRouteImport } from './routes/profil_.factures'
import { Route as ProfilAideRouteImport } from './routes/profil_.aide'
import { Route as ProfilActiviteRouteImport } from './routes/profil_.activite'
import { Route as TasksTaskIdRapportRouteImport } from './routes/tasks/$taskId_.rapport'
import { Route as TasksTaskIdRenderRouteImport } from './routes/tasks/$taskId.render'
import { Route as TasksTaskIdRenderVtRouteImport } from './routes/tasks/$taskId.render.vt'
import { Route as TasksTaskIdRenderVtSectionSubsectionRouteImport } from './routes/tasks/$taskId.render.vt.$section.$subsection'

const ResetRoute = ResetRouteImport.update({
  id: '/reset',
  path: '/reset',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfilRoute = ProfilRouteImport.update({
  id: '/profil',
  path: '/profil',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksTaskIdRoute = TasksTaskIdRouteImport.update({
  id: '/tasks/$taskId',
  path: '/tasks/$taskId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfilFacturesRoute = ProfilFacturesRouteImport.update({
  id: '/profil_/factures',
  path: '/profil/factures',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfilAideRoute = ProfilAideRouteImport.update({
  id: '/profil_/aide',
  path: '/profil/aide',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfilActiviteRoute = ProfilActiviteRouteImport.update({
  id: '/profil_/activite',
  path: '/profil/activite',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksTaskIdRapportRoute = TasksTaskIdRapportRouteImport.update({
  id: '/tasks/$taskId_/rapport',
  path: '/tasks/$taskId/rapport',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksTaskIdRenderRoute = TasksTaskIdRenderRouteImport.update({
  id: '/render',
  path: '/render',
  getParentRoute: () => TasksTaskIdRoute,
} as any)
const TasksTaskIdRenderVtRoute = TasksTaskIdRenderVtRouteImport.update({
  id: '/vt',
  path: '/vt',
  getParentRoute: () => TasksTaskIdRenderRoute,
} as any)
const TasksTaskIdRenderVtSectionSubsectionRoute =
  TasksTaskIdRenderVtSectionSubsectionRouteImport.update({
    id: '/$section/$subsection',
    path: '/$section/$subsection',
    getParentRoute: () => TasksTaskIdRenderVtRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/profil': typeof ProfilRoute
  '/reset': typeof ResetRoute
  '/profil/activite': typeof ProfilActiviteRoute
  '/profil/aide': typeof ProfilAideRoute
  '/profil/factures': typeof ProfilFacturesRoute
  '/tasks/$taskId': typeof TasksTaskIdRouteWithChildren
  '/tasks/$taskId/render': typeof TasksTaskIdRenderRouteWithChildren
  '/tasks/$taskId/rapport': typeof TasksTaskIdRapportRoute
  '/tasks/$taskId/render/vt': typeof TasksTaskIdRenderVtRouteWithChildren
  '/tasks/$taskId/render/vt/$section/$subsection': typeof TasksTaskIdRenderVtSectionSubsectionRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/profil': typeof ProfilRoute
  '/reset': typeof ResetRoute
  '/profil/activite': typeof ProfilActiviteRoute
  '/profil/aide': typeof ProfilAideRoute
  '/profil/factures': typeof ProfilFacturesRoute
  '/tasks/$taskId': typeof TasksTaskIdRouteWithChildren
  '/tasks/$taskId/render': typeof TasksTaskIdRenderRouteWithChildren
  '/tasks/$taskId/rapport': typeof TasksTaskIdRapportRoute
  '/tasks/$taskId/render/vt': typeof TasksTaskIdRenderVtRouteWithChildren
  '/tasks/$taskId/render/vt/$section/$subsection': typeof TasksTaskIdRenderVtSectionSubsectionRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/profil': typeof ProfilRoute
  '/reset': typeof ResetRoute
  '/profil_/activite': typeof ProfilActiviteRoute
  '/profil_/aide': typeof ProfilAideRoute
  '/profil_/factures': typeof ProfilFacturesRoute
  '/tasks/$taskId': typeof TasksTaskIdRouteWithChildren
  '/tasks/$taskId/render': typeof TasksTaskIdRenderRouteWithChildren
  '/tasks/$taskId_/rapport': typeof TasksTaskIdRapportRoute
  '/tasks/$taskId/render/vt': typeof TasksTaskIdRenderVtRouteWithChildren
  '/tasks/$taskId/render/vt/$section/$subsection': typeof TasksTaskIdRenderVtSectionSubsectionRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/profil'
    | '/reset'
    | '/profil/activite'
    | '/profil/aide'
    | '/profil/factures'
    | '/tasks/$taskId'
    | '/tasks/$taskId/render'
    | '/tasks/$taskId/rapport'
    | '/tasks/$taskId/render/vt'
    | '/tasks/$taskId/render/vt/$section/$subsection'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/profil'
    | '/reset'
    | '/profil/activite'
    | '/profil/aide'
    | '/profil/factures'
    | '/tasks/$taskId'
    | '/tasks/$taskId/render'
    | '/tasks/$taskId/rapport'
    | '/tasks/$taskId/render/vt'
    | '/tasks/$taskId/render/vt/$section/$subsection'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/profil'
    | '/reset'
    | '/profil_/activite'
    | '/profil_/aide'
    | '/profil_/factures'
    | '/tasks/$taskId'
    | '/tasks/$taskId/render'
    | '/tasks/$taskId_/rapport'
    | '/tasks/$taskId/render/vt'
    | '/tasks/$taskId/render/vt/$section/$subsection'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  ProfilRoute: typeof ProfilRoute
  ResetRoute: typeof ResetRoute
  ProfilActiviteRoute: typeof ProfilActiviteRoute
  ProfilAideRoute: typeof ProfilAideRoute
  ProfilFacturesRoute: typeof ProfilFacturesRoute
  TasksTaskIdRoute: typeof TasksTaskIdRouteWithChildren
  TasksTaskIdRapportRoute: typeof TasksTaskIdRapportRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset': {
      id: '/reset'
      path: '/reset'
      fullPath: '/reset'
      preLoaderRoute: typeof ResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profil': {
      id: '/profil'
      path: '/profil'
      fullPath: '/profil'
      preLoaderRoute: typeof ProfilRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/$taskId': {
      id: '/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/tasks/$taskId'
      preLoaderRoute: typeof TasksTaskIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profil_/factures': {
      id: '/profil_/factures'
      path: '/profil/factures'
      fullPath: '/profil/factures'
      preLoaderRoute: typeof ProfilFacturesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profil_/aide': {
      id: '/profil_/aide'
      path: '/profil/aide'
      fullPath: '/profil/aide'
      preLoaderRoute: typeof ProfilAideRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profil_/activite': {
      id: '/profil_/activite'
      path: '/profil/activite'
      fullPath: '/profil/activite'
      preLoaderRoute: typeof ProfilActiviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/$taskId_/rapport': {
      id: '/tasks/$taskId_/rapport'
      path: '/tasks/$taskId/rapport'
      fullPath: '/tasks/$taskId/rapport'
      preLoaderRoute: typeof TasksTaskIdRapportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/$taskId/render': {
      id: '/tasks/$taskId/render'
      path: '/render'
      fullPath: '/tasks/$taskId/render'
      preLoaderRoute: typeof TasksTaskIdRenderRouteImport
      parentRoute: typeof TasksTaskIdRoute
    }
    '/tasks/$taskId/render/vt': {
      id: '/tasks/$taskId/render/vt'
      path: '/vt'
      fullPath: '/tasks/$taskId/render/vt'
      preLoaderRoute: typeof TasksTaskIdRenderVtRouteImport
      parentRoute: typeof TasksTaskIdRenderRoute
    }
    '/tasks/$taskId/render/vt/$section/$subsection': {
      id: '/tasks/$taskId/render/vt/$section/$subsection'
      path: '/$section/$subsection'
      fullPath: '/tasks/$taskId/render/vt/$section/$subsection'
      preLoaderRoute: typeof TasksTaskIdRenderVtSectionSubsectionRouteImport
      parentRoute: typeof TasksTaskIdRenderVtRoute
    }
  }
}

interface TasksTaskIdRenderVtRouteChildren {
  TasksTaskIdRenderVtSectionSubsectionRoute: typeof TasksTaskIdRenderVtSectionSubsectionRoute
}

const TasksTaskIdRenderVtRouteChildren: TasksTaskIdRenderVtRouteChildren = {
  TasksTaskIdRenderVtSectionSubsectionRoute:
    TasksTaskIdRenderVtSectionSubsectionRoute,
}

const TasksTaskIdRenderVtRouteWithChildren =
  TasksTaskIdRenderVtRoute._addFileChildren(TasksTaskIdRenderVtRouteChildren)

interface TasksTaskIdRenderRouteChildren {
  TasksTaskIdRenderVtRoute: typeof TasksTaskIdRenderVtRouteWithChildren
}

const TasksTaskIdRenderRouteChildren: TasksTaskIdRenderRouteChildren = {
  TasksTaskIdRenderVtRoute: TasksTaskIdRenderVtRouteWithChildren,
}

const TasksTaskIdRenderRouteWithChildren =
  TasksTaskIdRenderRoute._addFileChildren(TasksTaskIdRenderRouteChildren)

interface TasksTaskIdRouteChildren {
  TasksTaskIdRenderRoute: typeof TasksTaskIdRenderRouteWithChildren
}

const TasksTaskIdRouteChildren: TasksTaskIdRouteChildren = {
  TasksTaskIdRenderRoute: TasksTaskIdRenderRouteWithChildren,
}

const TasksTaskIdRouteWithChildren = TasksTaskIdRoute._addFileChildren(
  TasksTaskIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  ProfilRoute: ProfilRoute,
  ResetRoute: ResetRoute,
  ProfilActiviteRoute: ProfilActiviteRoute,
  ProfilAideRoute: ProfilAideRoute,
  ProfilFacturesRoute: ProfilFacturesRoute,
  TasksTaskIdRoute: TasksTaskIdRouteWithChildren,
  TasksTaskIdRapportRoute: TasksTaskIdRapportRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
